export type SlideDirection = 'left' | 'right';

export function detectSwipe(distance: number, elapsed: number): SlideDirection | null {
  if (elapsed <= 0) return null;
  const velocity = Math.abs(distance) / elapsed;
  if (Math.abs(distance) >= 50 && velocity >= 0.3) {
    return distance < 0 ? 'left' : 'right';
  }
  return null;
}

export function createSwipeHandler(
  sliderEl: HTMLElement,
  onSlide: (direction: SlideDirection) => void,
): () => void {
  let startX = 0;
  let startTime = 0;

  const onTouchStart = (e: TouchEvent) => {
    startX = e.touches[0].clientX;
    startTime = Date.now();
  };

  const onTouchEnd = (e: TouchEvent) => {
    const endX = e.changedTouches[0].clientX;
    const elapsed = Date.now() - startTime;
    const distance = endX - startX;
    const direction = detectSwipe(distance, elapsed);
    if (direction) {
      onSlide(direction);
    }
  };

  sliderEl.addEventListener('touchstart', onTouchStart, { passive: true });
  sliderEl.addEventListener('touchend', onTouchEnd, { passive: true });

  return () => {
    sliderEl.removeEventListener('touchstart', onTouchStart);
    sliderEl.removeEventListener('touchend', onTouchEnd);
  };
}
